"use client";
import BottomNav from "@/Components/BottomNav";
import { useResponsive } from "@/Hooks";
import { usePathname } from "next/navigation";
import { FC, ReactNode, useEffect, useState } from "react";

interface LayoutClientProps {
  children?: ReactNode;
  pathname: string | null;
}

const LayoutClient: FC<LayoutClientProps> = ({
  children,
  pathname: _pathname,
}) => {
  const { isMobile } = useResponsive();
  const pathname = usePathname() ?? _pathname;
  const [showBottomNav, setShowBottomNav] = useState(false);

  useEffect(() => {
    void import("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  useEffect(() => {
    const isPanel = pathname?.toLowerCase()?.startsWith("/panel");
    setShowBottomNav(!!pathname && isMobile && !isPanel);
  }, [pathname, isMobile]);

  return (
    <>
      {children}
      {showBottomNav && <BottomNav />}
    </>
  );
};

export default LayoutClient;
